import { useTranslation } from "next-i18next";
import Column from "@components/CmsBlocks/column";

const FeaturedContent = (props: {
  Columns: {
    id: number,
    href: string,
    label: string,
    isExternal: boolean,
    Image: { data: { id: number, attributes: { url: string, alternativeText: string}} }
  }[]
}) => {
  const { t } = useTranslation("common");
  return (
    <div className={`grid grid-cols-${props.Columns.length / 2} md:grid-cols-${props.Columns.length} lg:grid-cols-${props.Columns.length}  `}>
      {
        props.Columns.map((column, index) => {

          const data = {
            Title: column.label,
            CTA: {
              href: column.href,
              isExternal: column.isExternal,
              label: column.label
            },
            Background: column.Image
          }

          return <div className="p-1" key={index}>

            <Column key={`block-index-${index}`} {...data} ></Column>

          </div>;
        })
      }
    </div>
  )
}

FeaturedContent.defaultProps = {};

export default FeaturedContent;
